if (!customElements.get('ep-shop-filters')) {
  customElements.define('ep-shop-filters', class extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.start();
    }
    async start() {
      this.root = this.closest('results-list');
      this.selects = [...this.querySelectorAll('select')];
      this.status = this.querySelector('[data-ep-count]');
      const grid = this.root.querySelector('.product-grid');
      if (!grid) { this.status.textContent = this.dataset.count.replace('__COUNT__', '0'); return; }
      grid.setAttribute('product-grid-view', 'default');
      try {
        const marker = this.root.querySelector('[data-ep-pages]');
        const pages = Number(marker?.dataset.epPages || 1);
        const current = Number(marker?.dataset.epPage || 1);
        const seen = new Set([...grid.querySelectorAll('[data-product-id]')].map(el => el.dataset.productId));
        for (let page = 1; page <= pages; page++) {
          if (page === current) continue;
          const url = new URL(location.href);
          url.searchParams.set('page', page);
          url.searchParams.set('section_id', this.dataset.section);
          const response = await fetch(url);
          if (!response.ok) throw new Error('Collection request failed');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const cards = doc.querySelectorAll('.product-grid__item[data-ep-product]');
          if (!cards.length) throw new Error('Collection cards missing');
          for (const card of cards) {
            if (!seen.has(card.dataset.productId)) {
              seen.add(card.dataset.productId);
              grid.append(card);
            }
          }
        }
        this.cards = [...grid.querySelectorAll('[data-ep-product]')].map(el => {
          const data = JSON.parse(el.dataset.epProduct);
          data.feelings = data.tags.filter(tag => tag.startsWith('Feeling: ')).map(tag => tag.slice(9).trim());
          data.sizeIndex = data.options.findIndex(name => /^size$/i.test(name));
          data.colorIndex = data.options.findIndex(name => /^(color|colour)$/i.test(name));
          return {el, data};
        });
        const values = {feeling:new Set(), size:new Set(), color:new Set(), category:new Set()};
        for (const {data} of this.cards) {
          data.feelings.forEach(v => values.feeling.add(v));
          if (data.category) values.category.add(data.category);
          for (const variant of data.variants) {
            if (!variant.available) continue;
            if (data.sizeIndex >= 0) values.size.add(variant.options[data.sizeIndex]);
            if (data.colorIndex >= 0) values.color.add(variant.options[data.colorIndex]);
          }
        }
        const sizeOrder = ['XXS','XS','S','M','L','XL','2XL','XXL','3XL','XXXL','4XL','5XL'];
        for (const select of this.selects) {
          const key = select.dataset.filter;
          const list = [...values[key]].sort((a,b) => {
            if (key === 'size') {
              const ai = sizeOrder.indexOf(a.toUpperCase()), bi = sizeOrder.indexOf(b.toUpperCase());
              if (ai >= 0 && bi >= 0) return ai - bi;
            }
            return a.localeCompare(b, undefined, {numeric:true});
          });
          list.forEach(value => {
            const label = key === 'feeling' ? this.getAttribute('data-mood-' + value.toLowerCase()) || value : value;
            select.add(new Option(key === 'color' && value === 'Faded Mustard' ? 'Yema' : label, value));
          });
          select.disabled = false;
          select.addEventListener('change', () => this.apply(true));
        }
        this.querySelector('[data-ep-clear]').addEventListener('click', () => {
          this.selects.forEach(s => s.value = '');
          this.apply(true);
        });
        this.restore = () => {
          const params = new URL(location.href).searchParams;
          this.selects.forEach(s => s.value = params.get('ep_' + s.dataset.filter) || '');
          this.apply(false);
        };
        window.addEventListener('popstate', this.restore);
        this.setAttribute('data-ready','');
        this.root.querySelectorAll('pagination-controls, .pagination, nav[aria-label="Pagination"]').forEach(el => el.hidden = true);
        this.restore();
      } catch (error) {
        this.status.textContent = this.dataset.error;
      }
    }
    // Pick the variant that matches the active color and size filters.
    pickVariant(data, filters) {
      if (!filters.size && !filters.color) return null;
      return data.variants.find(v => v.available
        && (!filters.size || v.options[data.sizeIndex] === filters.size)
        && (!filters.color || v.options[data.colorIndex] === filters.color)) || null;
    }
    // Point every product link on the card at the picked variant, or back to the plain product URL.
    setCardLinks(el, variant) {
      el.querySelectorAll('a[href*="/products/"]').forEach(link => {
        if (link.dataset.epHref === undefined) link.dataset.epHref = link.getAttribute('href');
        if (!variant) { link.setAttribute('href', link.dataset.epHref); return; }
        const url = new URL(link.dataset.epHref, location.origin);
        url.searchParams.set('variant', variant.id);
        link.setAttribute('href', url.pathname + url.search + url.hash);
      });
    }
    // Show the picked color's photo as the card's main image, or restore the original.
    setCardImage(el, variant, data) {
      const gallery = el.querySelector('.card-gallery');
      const img = gallery?.querySelector('img');
      if (!img) return;
      if (img.dataset.epSrc === undefined) {
        img.dataset.epSrc = img.getAttribute('src') || '';
        img.dataset.epSrcset = img.getAttribute('srcset') || '';
        img.dataset.epAlt = img.alt;
      }
      if (variant && variant.img) {
        img.setAttribute('srcset', variant.srcset || variant.img);
        img.setAttribute('src', variant.img);
        img.alt = variant.alt || img.dataset.epAlt;
      } else {
        if (img.dataset.epSrcset) img.setAttribute('srcset', img.dataset.epSrcset); else img.removeAttribute('srcset');
        img.setAttribute('src', img.dataset.epSrc);
        img.alt = img.dataset.epAlt;
      }
      const hover = variant ? variant.hover : data.hover;
      const slides = gallery.querySelectorAll('slideshow-slide');
      const secondary = slides[1]?.querySelector('img');
      if (secondary) {
        if (secondary.dataset.epAlt === undefined) secondary.dataset.epAlt = secondary.alt;
        secondary.src = hover || img.src;
        secondary.srcset = hover || img.srcset || img.src;
        secondary.alt = variant ? (variant.hoverAlt || img.alt) : secondary.dataset.epAlt;
      }
      const hasPair = Boolean(hover && secondary);
      if (hasPair) {
        gallery.setAttribute('on:pointerenter', '/previewImage');
        gallery.setAttribute('on:pointerleave', '/resetImage');
      } else {
        gallery.removeAttribute('on:pointerenter');
        gallery.removeAttribute('on:pointerleave');
      }
      const slideshow = gallery.querySelector('slideshow-component');
      if (typeof slideshow?.select === 'function') slideshow.select(0, undefined, {animate:false});
    }
    apply(updateUrl) {
      const filters = Object.fromEntries(this.selects.map(s => [s.dataset.filter, s.value]));
      let count = 0;
      for (const {el,data} of this.cards) {
        const match = (!filters.feeling || data.feelings.includes(filters.feeling))
          && (!filters.category || data.category === filters.category)
          && ((!filters.size && !filters.color) || data.variants.some(v => v.available
            && (!filters.size || v.options[data.sizeIndex] === filters.size)
            && (!filters.color || v.options[data.colorIndex] === filters.color)));
        el.hidden = !match;
        if (match) count++;
        const variant = match ? this.pickVariant(data, filters) : null;
        this.setCardLinks(el, variant);
        this.setCardImage(el, filters.color ? variant : null, data);
      }
      this.status.textContent = this.dataset.count.replace('__COUNT__', count);
      this.querySelector('[data-ep-empty]').hidden = count !== 0;
      this.querySelector('[data-ep-clear]').hidden = !Object.values(filters).some(Boolean);
      this.selects.forEach(s => s.toggleAttribute('data-active', Boolean(s.value)));
      if (updateUrl) {
        const url = new URL(location.href);
        for (const [key,value] of Object.entries(filters)) {
          if (value) url.searchParams.set('ep_' + key, value);
          else url.searchParams.delete('ep_' + key);
        }
        url.searchParams.delete('page');
        history.pushState({}, '', url);
      }
    }
    disconnectedCallback() { if (this.restore) window.removeEventListener('popstate', this.restore); }
  });
}

